import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { RequestsService } from '../services/requests.service';
import { DrVideoRequest } from '../models/dr-video-request.model';
import { LoaderService } from '../../../../shared/services/loader.service';
import { Dependent } from '../../../user/models/user-profile.model';

@Component({
  selector: 'app-medical-virtual',
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './medical-virtual.component.html',
  styleUrl: './medical-virtual.component.scss'
})
export class MedicalVirtualComponent {
  @Input() nameService: string = '';
  
  public URL: SafeResourceUrl = '';
  dependent: Dependent[] = [];
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  selectedPatient = 'titular';


  constructor(
    private route: ActivatedRoute, 
    private sanitizer: DomSanitizer,
    private router: Router,
    private userService: UserService,
    private requestServ: RequestsService,
    private loader: LoaderService
  ) {
    if(history.state.dsSubServicio?.includes('Consulta Médica Virtual')){
      const url = history.state.url;
      this.URL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  
  ngOnInit(): void {
    this.getDetailUser();
  }

  getDetailUser() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }

    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  confirm(): void {
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const nameWithoutAccents = this.removeAccents(selectedName);
    this.callDrVideoService(nameWithoutAccents, '');
    
    // this.generateExpediente();
  }

  private removeAccents(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // TODO: Uncomment when expediente generation is needed
  // generateExpediente() {
  //   const solicitudData = localStorage.getItem('solicitudData');
  //   let servicio;
  //   
  //   if (solicitudData) {
  //     servicio = JSON.parse(solicitudData).servicio;
  //   } else {
  //     const params = this.route.snapshot.queryParams;
  //     servicio = {
  //       clServicio: params['clServicio'] || 4,
  //       clSubservicio: params['clSubServicio'] || 433,
  //       dsServicio: params['dsServicio'] || 'Asistencia Médica',
  //       dsSubServicio: params['dsSubServicio'] || 'Consulta Médica Virtual'
  //     };
  //   }
  //   
  //   this.loader.show();
  //   
  //   const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
  //   const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
  //   
  //   const accountData = localStorage.getItem('account');
  //   const accountId = accountData ? JSON.parse(accountData) : 536;
  //   
  //   const payload = {
  //     identifier: {
  //       tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
  //       app: 'PortalAsistencia'
  //     },
  //     petition: {
  //       serviceId: servicio.clServicio,
  //       subServiceId: servicio.clSubservicio.toString(),
  //       hasAssistance: false,
  //       key: this.keyOwner,
  //       areaCode1: '044',
  //       phone1: this.phoneOwner,
  //       stateCode: '',
  //       municipalityCode: '',
  //       statusId: 0,
  //       accountId: accountId,
  //       appUserId: 1,
  //       countryId: 115,
  //       contactTypeId: 15,
  //       serviceTypeId: 1,
  //       sendCharge: false,
  //       hasAppointment: false,
  //       isRelevant: false,
  //       gender: 1,
  //       isOk: true,
  //       hasQuotation: false,
  //       isSise2: true,
  //       serviceReceptionId: 10,
  //       personId: 1,
  //       username: this.nameOwner,
  //       paternalSurname: '',
  //       userSecondLastName: '',
  //       contactName: selectedName,
  //       userFirstNamePf: firstName,
  //       userLastNamePf: lastName,
  //       userSecondLastNamePf: secondLastName,
  //       ourUser: this.nameOwner,
  //       externalCabRepName: 'API CLIENTES',
  //       folio: crypto.randomUUID(),
  //       longitude: '',
  //       latitude: '',
  //       incidentDescription: `Consulta médica virtual`,
  //       clRecepcionServicio: 10
  //     }
  //   };

  //   this.requestServ.sendMedicaTelefonicaRequest(payload).subscribe({
  //     next: (res) => {
  //       this.loader.hide();
  //       console.log('Expediente generado:', res);
  //       
  //       const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
  //       
  //       const assistanceData = {
  //         clave: res.response.clave || '',
  //         clexpediente: expediente,
  //         nuestrousuario: res.response.nuestrousuario || this.nameOwner,
  //         clcuenta: res.response.clcuenta || '',
  //         nombre: 'CONSULTA MÉDICA VIRTUAL',
  //         clservicio: res.response.clservicio || servicio.clServicio,
  //         dsservicio: servicio.dsServicio || 'Asistencia Médica',
  //         clsubservicio: res.response.clsubservicio || servicio.clSubservicio,
  //         dssubservicio: servicio.dsSubServicio || 'Consulta Médica Virtual',
  //         clestatus: res.response.clestatus || '0',
  //         dsestatus: 'Abierto',
  //         fecharegistro: res.response.fecharegistro || new Date().toISOString()
  //       };
  //       
  //       if (solicitudData) {
  //         localStorage.removeItem('solicitudData');
  //       }
  //       
  //       // Call DR Video service after successful expediente creation
  //       this.callDrVideoService(selectedName, expediente);
  //     },
  //     error: (err) => {
  //       this.loader.hide();
  //       console.error('Error al generar expediente:', err);
  //     }
  //   });
  // }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || '',
      secondLastName: parts.slice(2).join(' ') || ''
    };
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }



  goToAddDependent(): void {
    this.router.navigate(['/add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }



  private callDrVideoService(selectedName: string, expediente: string): void {
    const userData = localStorage.getItem('user');
    const accountData = localStorage.getItem('account');
    
    if (!userData || !accountData) {
      console.error('Missing user or account data');
      return;
    }

    const userObj = JSON.parse(userData);
    const accountId = JSON.parse(accountData);
    const { firstName, lastName } = this.splitFullName(selectedName);

    const phoneWithCountryCode = this.phoneOwner.startsWith('52') ? this.phoneOwner : `52${this.phoneOwner}`;
    
    // Generate externalId based on selection
    let externalId = this.keyOwner;
    if (this.selectedPatient !== 'titular') {
      const selectedDependent = this.dependent.find(dep => dep.name === this.selectedPatient);
      if (selectedDependent) {
        externalId = `${this.keyOwner}-D${selectedDependent.dependent}`;
      }
    }
    
    const drVideoRequest: DrVideoRequest = {
      name: firstName,
      lastName: lastName,
      externalId: externalId,
      email: userObj.email || '',
      phoneNumber: phoneWithCountryCode,
      phoneNumber2: phoneWithCountryCode,
      account: {
        id: accountId
      }
    };

    this.loader.show();
    
    this.requestServ.getDrVideoUrl(drVideoRequest).subscribe({
      next: (response) => {
        this.loader.hide();
        console.log('DR Video URL obtained:', response);
        if (response.data && response.data.url) {
          // Navigate to DR Video component with the URL
          this.router.navigate(['/service/dr-video'], {
            state: { videoUrl: response.data.url }
          });
        }
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error getting DR Video URL:', err);
      }
    });
  }
}
